export function formatMoney(value: string | number, options: { signed?: boolean; compact?: boolean } = {}) {
  const number = Number(value);
  const formatted = new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
    currencyDisplay: "symbol",
    minimumFractionDigits: options.compact && Number.isInteger(number) ? 0 : 2,
    maximumFractionDigits: 2
  }).format(Math.abs(number)).replace("MYR", "RM");
  if (options.signed && number > 0) return `+${formatted}`;
  return number < 0 ? `−${formatted}` : formatted;
}

export function formatDate(value: string, options: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" }) {
  return new Intl.DateTimeFormat("en-MY", { ...options, timeZone: "Asia/Kuala_Lumpur" }).format(new Date(`${value}T00:00:00+08:00`));
}

export function todayMalaysia() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kuala_Lumpur" });
}
